'use strict';

const template = require('../templates/RequestChangesModal.ejs');
const modal    = require('helpers/modal');

module.exports = Backbone.View.extend({
    events: {
        'click .js-send': 'actionSend'
    },

    render: function(event) {
        this.event = event;
        this.$el.html(template({}));
        return this;
    },

    actionSend: function() {
        var text = this.$('.js-text').val();
        app.employee.requestChanges(text).then(() => {
            this.hide();
            modal.showAlertSuccess('Your request has been sent!');
        });
    },

    show: function() {
        this.$('.js-approval-modal').modal('show');
        this.$('textarea').focus();
    },

    hide: function() {
        this.$('.js-approval-modal').modal('hide');
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/RequestChangesModal.js